import { render, staticRenderFns } from "./user-panel.vue?vue&type=template&id=50a34bec"
import script from "./user-panel.vue?vue&type=script&lang=js"
export * from "./user-panel.vue?vue&type=script&lang=js"
import style0 from "./user-panel.vue?vue&type=style&index=0&id=50a34bec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports